
import { defineComponent } from 'vue'
import { usePermissions } from '@/utils/usePermissions'

export default defineComponent({
  setup() {
    const { canManageUsers } = usePermissions()
    return { canManageUsers }
  }
})
